import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick,
  disabled = false,
  type = 'submit'
}: ButtonProps) {
  const baseStyles = 'inline-block py-3 px-8 font-currency tracking-wide text-center transition-all duration-300 relative border border-ink-900';
  const variantStyles = {
    primary: 'bg-ink-900 text-white',
    secondary: 'bg-white text-ink-900'
  };
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';
  return <button className={`${baseStyles} ${variantStyles[variant]} ${disabledStyles} ${className} group`} onClick={onClick} disabled={disabled} type={type} data-id="element-49">
      {/* Decorative corner elements */}
      <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-current opacity-40 group-hover:opacity-70 transition-opacity" data-id="element-50"></div>
      <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-current opacity-40 group-hover:opacity-70 transition-opacity" data-id="element-51"></div>
      <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-current opacity-40 group-hover:opacity-70 transition-opacity" data-id="element-52"></div>
      <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-current opacity-40 group-hover:opacity-70 transition-opacity" data-id="element-53"></div>
      {/* Button content */}
      <span className="relative z-10" data-id="element-54">{children}</span>
    </button>;
}